import React from 'react';
import StandardFrameSheet from './sheets/StandardFrameSheet';
import AutoFillSheetMobile from './sheets/AutoFillSheetMobile';
import { isMobile } from 'utils/platform';
import AutoFillCornerWallInfoSheet from './sheets/AutoFillCornerWallInfoSheet';
import AutoFillSingleWallInfoSheet from './sheets/AutoFillSingleWallInfoSheet';

export const AutofillPaxUi = () => {
  return (
    <>
      {isMobile() && <AutoFillSheetMobile />}
      <StandardFrameSheet />
      <AutoFillCornerWallInfoSheet />
      <AutoFillSingleWallInfoSheet />
    </>
  );
};
